import { Box } from "@bigcommerce/big-design";
import { theme } from "@bigcommerce/big-design-theme";
import styled from "styled-components";

export const StyledMessageBox = styled(Box)`
    margin-bottom: ${theme.spacing.medium};
    div[role="alert"] {
        background-color: ${theme.colors.danger20};
    }
`;
